import React, { useEffect, useState } from "react";
import PlusCircleIcon from "./PlusCircleIcon";
import GuardrailGenerator from "./GuardrailGenerator";

export default function DisallowedTopics({
  promptHeader,
  guardrail,
  organization,
  isMasterPrompt,
  handlePublishButton,
}) {
  const [disallowedTopics, setDisallowedTopics] = useState([]);
  const [newTopic, setNewTopic] = useState("");
  const [updatedGuardrail, setUpdatedGuardrail] = useState(guardrail || {});

  useEffect(() => {
    const content = guardrail?.promptContent || "";
    const items = content
      .split("\n") // Split by newline
      .map((line) => line.trim())
      .filter((line) => line.startsWith('- "') && line.endsWith('"')) // Ensure correct format
      .map((line) => line.substring(3, line.length - 1)); // Extract content between '- "' and '"'
    setDisallowedTopics(items);
  }, [guardrail]);

  const handleAdd = () => {
    setDisallowedTopics([...disallowedTopics, newTopic]);
    setNewTopic("");
  };

  return (
    <div className="prompt-content-body">
      <h4>{promptHeader}</h4>
      {false && (
        <div className="disallowed-topics-add">
          <input
            type="text"
            placeholder="Add Topic"
            value={newTopic}
            onChange={(e) => setNewTopic(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleAdd();
              }
            }}
          />
          <button onClick={() => handleAdd()}>
            <PlusCircleIcon className="plus-icon" />
          </button>
        </div>
      )}
      <div className="disallowed-topics-container">
        <p className="prompt-content-subtitle">
          Respond with the standard refusal sentence above if the user's request
          is **primarily** about any topic in this list.
        </p>
        <GuardrailGenerator
          updatedGuardrail={updatedGuardrail}
          setUpdatedGuardrail={setUpdatedGuardrail}
        />
      </div>
      {(isMasterPrompt || organization?.value?.length > 0) && (
        <div className="publish-guardrails">
          <button
            className="publish-guardrails-button"
            onClick={() => handlePublishButton(updatedGuardrail)}
          >
            Publish
          </button>
        </div>
      )}
    </div>
  );
}
